export { SignalBadge, type SignalBadgeStatus } from './SignalBadge';
